import { withRFSToken } from '../../Services/axios.js';
import { toast } from 'react-toastify';
import { Modal, Button } from "react-bootstrap";

export const CallApi = async ({ endPoint, payload, onSuccess, onError, method = 'post' }) => {
  try {
    const config = {
      method,
      url: endPoint,
      data: payload
    };
    const res = await withRFSToken(config)
      .then(function (res) {
        onSuccess(res)
      });
  } catch (error) {
    // console.error('Error fetching data:', error);
    onError ? onError(error) : toast.error("Network error!");
  }
}

export const TabButton = ({
  value,
  label,
  selectedButton,
  onClick,
  activeIcon,
  inactiveIcon,
  className = 'exportbtn me-3'
}) => {
  const isActive = selectedButton === value;

  return (
    <button className={`${className} ${isActive ? 'active' : ''}`} onClick={() => onClick(value)}>
      <img src={isActive ? activeIcon : inactiveIcon} alt={label} />
      <span>{label}</span>
    </button>
  );
};

export const getTodayDate = (inputDate = null, format = 'YMD') => {
  const date = inputDate ? new Date(inputDate) : new Date();

  const year = date.getFullYear();
  const month = String(date.getMonth() + 1).padStart(2, '0');
  const day = String(date.getDate()).padStart(2, '0');

  if (format === 'DMY') {
    return `${day}-${month}-${year}`;
  } else {
    return `${year}-${month}-${day}`;
  }
};
export const getTodayDateTime = (inputDate = null, format = 'YMD') => {
  const date = inputDate ? new Date(inputDate) : new Date();

  const year = date.getFullYear();
  const month = String(date.getMonth() + 1).padStart(2, '0');
  const day = String(date.getDate()).padStart(2, '0');

  const hours = String(date.getHours()).padStart(2, '0');
  const minutes = String(date.getMinutes()).padStart(2, '0');

  switch (format) {
    case 'DATETIME_LOCAL':
      return `${year}-${month}-${day}T${hours}:${minutes}`;

    case 'DMY':
      return `${day}-${month}-${year} ${hours}:${minutes}`;

    case 'DMY_SLASH':
      return `${day}/${month}/${year} ${hours}:${minutes}`;

    case 'HM_DM':
      const monthShort = date.toLocaleString('en-US', { month: 'short' }).toUpperCase();
      return `${hours}:${minutes} ${day} ${monthShort}`;

    default:
      return `${year}-${month}-${day} ${hours}:${minutes}`;
  }
};


export const applyOffsetToDateTime = (dateTimeStr, fmt = "L") => {
  if (!dateTimeStr) return "-";

  // user selected timezone offset (target timezone)
  const offset = JSON.parse(localStorage.getItem("timeZone") || "{}")?.timezone_data?.value || "+00:00";

  const parseOffsetMinutes = (off) => {
    const sign = off[0] === "-" ? -1 : 1;
    const [h, m] = off.slice(1).split(":").map(Number);
    return sign * (h * 60 + m);
  };

  // ---- Step 1: parse input as UTC (because it ends with Z) ----
  const dt = new Date(dateTimeStr); // ISO string -> Date in UTC internally
  if (isNaN(dt.getTime())) return "-";

  // ---- Step 2: apply user's offset (UTC -> target timezone) ----
  const targetOffsetMin = parseOffsetMinutes(offset);
  dt.setMinutes(dt.getMinutes() + targetOffsetMin);

  // output formatting
  if (fmt === "L") {
    return dt.toLocaleString("en-IN", {
      timeZone: "UTC",
      day: "2-digit",
      month: "short",
      year: "numeric",
      hour: "2-digit",
      minute: "2-digit",
      hour12: false,
    });
  }

  // fmt === "H" => "YYYY-MM-DD HH:mm"
  const pad = (n) => String(n).padStart(2, "0");
  return `${dt.getFullYear()}-${pad(dt.getMonth() + 1)}-${pad(
    dt.getDate()
  )} ${pad(dt.getHours())}:${pad(dt.getMinutes())}`;
};

export const jqxCookieCall = () => {
  const originalOpen = XMLHttpRequest.prototype.open;
  XMLHttpRequest.prototype.open = function (method, url, ...args) {
    originalOpen.call(this, method, url, ...args);
    // if (url.includes(process.env.REACT_APP_RFS_URL)) {
    this.withCredentials = true;
    // }
  };
}

export const Logout = (api = false) => {
  if (!api) {
    localStorage.clear();
    sessionStorage.clear();
    window.location.replace('/Login');
  }
  CallApi({
    endPoint: "/logout",
    payload: {},
    method: "post",
    onSuccess: () => {
      localStorage.clear();
      sessionStorage.clear();
      window.location.replace('/Login');
    },
    onError: (error) => {
      localStorage.clear();
      sessionStorage.clear();
      window.location.replace('/Login');
    }
  });
}


export const CommonModal = ({ show, onHide, title, subTitle, onSubmit, closeClick, className, mSize, footer, children }) => {
  const handleClose = () => {
    if (closeClick) {
      closeClick();
    }
  }
  return (
    <Modal show={show} {...(onHide && { onHide })} centered className={className} size={mSize} backdrop="static">
      <Modal.Header closeButton> {/* onClick={handleClose} */}
        <Modal.Title>{title}{subTitle && <p>{subTitle}</p>}</Modal.Title>
      </Modal.Header>

      <Modal.Body>
        {children}
      </Modal.Body>

      <Modal.Footer>
        {footer}
      </Modal.Footer>
    </Modal>
  );
};